import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { MenuProps } from 'antd';

import { useCurrentUserQuery } from 'entities/user/api';
import { useInvoiceStatus } from 'features/navigation/model/useInvoiceStatus';
import { MpBadge } from 'shared/ui/Badge/Badge';
import { MenuStyled } from './ApplicationTabs.styles';

import './ApplicationTabs.css';

export const ApplicationTabs: React.FC = () => {
	const { t } = useTranslation();
	const defaultTab = sessionStorage.getItem(`activeTab`) ? sessionStorage.getItem(`activeTab`) : `1`;
	const [current, setCurrent] = useState(defaultTab);
	const { data: user } = useCurrentUserQuery();
	const invoiceStatus = useInvoiceStatus();

	const getTab = (): string => {
		switch (window.location.pathname) {
			case `/`:
				return `1`;
			case `/my`:
				return `2`;
			case `/faq`:
				return `3`;
			default:
				return `0`;
		}
	};

	useEffect(() => {
		setCurrent(getTab());
	}, []);

	if (!user) {
		return null;
	}

	const onClick: MenuProps['onClick'] = e => {
		sessionStorage.setItem(`activeTab`, e.key);
		setCurrent(e.key);
	};

	const menuItems: MenuProps['items'] = [
		{
			key: `1`,
			label: <Link to='/'>{t(`Marketplace_All_Apps`)}</Link>,
		},
		{
			key: `2`,
			label: (
				<Link to='/my'>
					<p style={{ margin: `0`, position: `relative` }}>
						{t(`Marketplace_My_Apps_And_Subscriptions`)}
						{!!invoiceStatus && <MpBadge color='error' />}
					</p>
				</Link>
			),
		},
	];

	return (
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		// eslint-disable-next-line prettier/prettier
		<MenuStyled onClick={onClick} selectedKeys={[current]} mode='horizontal' items={menuItems} className='header-nav' />
	);
};
